import React, {useEffect, useState} from "react";
import {Input, Label} from "reactstrap";

const TextInput = ({disabled, updateParent, label, initialValue, placeholder, style, error}) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        if (initialValue) setValue(initialValue);
    }, [initialValue])

    return (
        <>
            {label && <Label>{label}</Label>}
                <Input
                    placeholder={label || placeholder}
                    disabled={disabled}
                    value={value || ""}
                    onChange={(e) => setValue(e.target.value)}
                    onBlur={() => updateParent(value)}
                    style={style}
                />
                {error && (
                    <Label className="text-danger mt-2">{error}</Label>
                )}
        </>
    );
};

export default TextInput;
